// extracted by mini-css-extract-plugin
export default {"warningMessage":"warningMessage_warningMessage__haqrE"};